export interface Signature {
  Element: HTMLTextAreaElement;
  Args: {
    value: string;
    onChange: (event: Event) => void;
    propertyName?: string;
    rows?: number | string;
    labelName?: string;
    isMandatory?: boolean;
    displaySubText?: boolean;
    subText?: string;
    placeholder?: string;
    isReadOnly?: boolean;
  };
  Blocks: { default: [] };
}

import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
export default class LabeledTextAreaComponent extends Component<Signature> {
  htmlSafe = htmlSafe;

  <template>
    <label>
      {{! @glint-expect-error }}
      {{this.htmlSafe @labelName}}{{if @isMandatory ' *'}}
    </label>

    {{#if @displaySubText}}
      <p class='semeia faded-text-color' data-test-subtext>
        {{@subText}}
      </p>
    {{/if}}

    <textarea
      value={{@value}}
      {{! @glint-expect-error }}
      oninput={{@onChange}}
      rows={{if @rows @rows 5}}
      class='ui input'
      placeholder={{@placeholder}}
      readonly={{@isReadOnly}}
      data-test-textarea='{{@propertyName}}'
      ...attributes
    ></textarea>
  </template>
}
